import type { ErrorComponentProps } from '@tanstack/react-router';

import { t } from '@web/i18n';
import { Spinner } from '@web/ui/core';

const CONTAINER = 'flex min-h-screen items-center justify-center bg-background px-6';
const STACK = 'flex flex-col items-center gap-3';
const HEADLINE = 'text-display text-2xl';

export function AuthCallbackPending(): React.JSX.Element {
  return (
    <div role="status" aria-live="polite" className={CONTAINER}>
      <div className={STACK}>
        <Spinner size="lg" />
        <p className={`${HEADLINE} text-foreground`}>{t('auth.callback.pending')}</p>
      </div>
    </div>
  );
}

export function AuthCallbackError({ error }: Readonly<ErrorComponentProps>): React.JSX.Element {
  const message = error instanceof Error ? error.message : null;
  return (
    <div role="alert" aria-live="polite" className={CONTAINER}>
      <div className={STACK}>
        <p className={`${HEADLINE} text-destructive`}>{t('auth.callback.error')}</p>
        {message ? <p className="text-base text-muted-foreground">{message}</p> : null}
      </div>
    </div>
  );
}
